import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LoadingSpinner from '../LoadingSpinner';
import './Button.css';

function getButtonClassName(colorScheme, inverted, disabled, loading, open) {
  const classNameMap = {
    basic: 'button--basic',
    disabled: 'button--disabled',
    loading: 'button--loading'
  };

  let className = loading ? classNameMap.loading : '';

  className += ` ${classNameMap[disabled ? 'disabled' : colorScheme]}`;

  if (inverted) {
    className = `${className} --inverted`;
  }

  if (open) {
    className += ` --open`;
  }

  return `button ${className}`;
}

function Button(props) {
  const { IconLeft, IconRight, type } = props;
  const buttonClass = getButtonClassName(
    props.colorScheme,
    props.inverted,
    props.disabled,
    props.loading,
    props.open
  );

  const iconClass = 'button__icon';

  return (
    <button
      className={classNames(buttonClass, props.className)}
      disabled={props.disabled}
      type={type}
      onClick={props.onClick}
      onKeyPress={props.onClick}
      tabIndex={props.tabIndex}
      aria-label={props.ariaLabel}
    >
      {IconLeft ? (
        <IconLeft width={24} height={24} className={iconClass} />
      ) : null}
      &nbsp;
      {props.children || props.label}
      {props.loading && <LoadingSpinner />}
      &nbsp;
      {IconRight ? (
        <IconRight width={24} height={24} className={iconClass} />
      ) : null}
    </button>
  );
}

Button.defaultProps = {
  children: null,
  label: null,
  className: null,
  colorScheme: 'blue',
  inverted: false,
  disabled: false,
  loading: false,
  IconLeft: null,
  IconRight: null,
  onClick: () => {},
  tabIndex: null,
  type: 'submit',
  ariaLabel: null,
  open: false
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  colorScheme: PropTypes.oneOf(['red', 'green', 'blue', 'basic']),
  disabled: PropTypes.bool,
  inverted: PropTypes.bool,
  loading: PropTypes.bool,
  IconLeft: PropTypes.func,
  IconRight: PropTypes.func,
  onClick: PropTypes.func,
  tabIndex: PropTypes.string,
  type: PropTypes.string,
  ariaLabel: PropTypes.string,
  open: PropTypes.bool
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/buttons/Button.js